import React, { useEffect } from 'react';
import ExperienceCard from './ExperienceCard/ExperienceCard';
import './experience.css';

const Experience = ({ data }) => {
  
  return (
    <div className='experience__container'> 
      <h1>EXPERIENCIA</h1>
      <div className="experience__cards-container">
        {data && data.length > 0 ? (
          data.map((experience, index) => (
            <ExperienceCard key={index} data={experience} />
          ))
        ) : (
          <p className="experience__empty-message">No hay experiencias disponibles</p>
        )}
      </div>  
    </div>
  );
};

export default Experience;
